.sidebar {
  top: 55px !important;
  width: 90px !important;
  z-index: 100 !important;
  box-shadow: none !important;
}
